import { render, staticRenderFns } from "./listado-rubros.vue?vue&type=template&id=1b9ff3cc&"
import script from "./listado-rubros.vue?vue&type=script&lang=js&"
export * from "./listado-rubros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports